import { render, staticRenderFns } from "./MegaMenuPanel.vue?vue&type=template&id=56c9c3e3&scoped=true&"
import script from "./MegaMenuPanel.vue?vue&type=script&lang=js&"
export * from "./MegaMenuPanel.vue?vue&type=script&lang=js&"
import style0 from "./MegaMenuPanel.vue?vue&type=style&index=0&id=56c9c3e3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c9c3e3",
  null
  
)

export default component.exports